import { q } from 'groqd'

/** Looks up the comparison table _ref on an abstractProduct by its slug key */
export const abstractProductComparisonTableRefQuery = q('*')
  .filter('_type == "abstractProduct" && abstractProductKey.current == $key')
  .grab({
    comparisonTableRef: ['coverageComparisonTable._ref', q.string().nullable()],
  })
  .slice(0)

export const tableQuery = q('*')
  .filter('_type == "table" && _id == $id')
  .grab({
    _type: q.literal('table'),
    market: q.string(),
    title: ['title[$lang]', q.string()],
    description: ['description[$lang]', q.string()],
    itemKey: ['itemKey.current', q.string()],
    header: q('header')
      .filter()
      .grab({
        key: ['itemKey.current', q.string()],
        title: ['title[$lang]', q.string()],
        icon: ['icon.medium.name', q.string().nullable()],
      }),
    categoryRows: q('categoryRows')
      .filter()
      .grab({
        isExpandedByDefault: q.boolean(),
        key: ['itemKey.current', q.string()],
        title: ['title[$lang]', q.string()],
        rows: q('rows')
          .filter()
          .grab({
            key: ['itemKey.current', q.string()],
            isExpandedByDefault: q.boolean(),
            title: ['title[$lang]', q.string()],
            rowData: q('rowData')
              .filter()
              .grab({
                key: ['itemKey.current', q.string()],
                type: q.union([q.literal('string'), q.literal('boolean')]),
                value: ['value[$lang]', q.string()],
              }),
          }),
      }),
  })
  .slice(0)
